/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCheckoutFullfillmentShippings200ResponseAllOfData } from './GetCheckoutFullfillmentShippings200ResponseAllOfData';
import {
    GetCheckoutFullfillmentShippings200ResponseAllOfDataFromJSON,
    GetCheckoutFullfillmentShippings200ResponseAllOfDataFromJSONTyped,
    GetCheckoutFullfillmentShippings200ResponseAllOfDataToJSON,
} from './GetCheckoutFullfillmentShippings200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCheckoutFullfillmentShippings200ResponseAllOf
 */
export interface GetCheckoutFullfillmentShippings200ResponseAllOf {
    /**
     * 
     * @type {GetCheckoutFullfillmentShippings200ResponseAllOfData}
     * @memberof GetCheckoutFullfillmentShippings200ResponseAllOf
     */
    data: GetCheckoutFullfillmentShippings200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetCheckoutFullfillmentShippings200ResponseAllOf interface.
 */
export function instanceOfGetCheckoutFullfillmentShippings200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetCheckoutFullfillmentShippings200ResponseAllOfFromJSON(json: any): GetCheckoutFullfillmentShippings200ResponseAllOf {
    return GetCheckoutFullfillmentShippings200ResponseAllOfFromJSONTyped(json, false);
}

export function GetCheckoutFullfillmentShippings200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCheckoutFullfillmentShippings200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCheckoutFullfillmentShippings200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetCheckoutFullfillmentShippings200ResponseAllOfToJSON(value?: GetCheckoutFullfillmentShippings200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCheckoutFullfillmentShippings200ResponseAllOfDataToJSON(value.data),
    };
}

